import { styled } from '@mui/material';
import { Select as CommonSelect } from 'components/mui/common/Select';

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: '8px',
  '& .MuiTypography-root': {
    whiteSpace: 'nowrap',
  },

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const Select = styled(CommonSelect)(() => ({
  width: '75px',
  textAlign: 'center',
}));
